/* eslint-disable */
import React, { useCallback, useEffect, useState } from 'react';
import propTypes from 'prop-types';
import { Select } from 'antd';

const VALUE_ALL = 'VALUE_ALL';
const SearchSelect = React.forwardRef(function SearchSelect({ value, children, onChange = '', className = '', style = {} }, ref) {

  const [val, setVal] = useState(VALUE_ALL);
  useEffect(() => {
    if ([undefined, null, ''].includes(value)) {
      setVal(VALUE_ALL);
    } else {
      setVal(value);
    }
  }, [value]);

  const onValChange = useCallback(
    (val, e) => {
      if (val === VALUE_ALL) {
        onChange(undefined, e);
        setVal(VALUE_ALL);
      } else {
        setVal(val);
        onChange(val, e);
      }
    },
    [onChange]
  );

  return (
    <Select ref={ref} style={style} value={val} onChange={onValChange} className={className}>
      <Select.Option value={VALUE_ALL}>{'全部'}</Select.Option>
      {children}
    </Select>
  );
});

SearchSelect.propTypes = {
  value: propTypes.oneOfType([propTypes.string, propTypes.number]),
  onChange: propTypes.func,
  className: propTypes.string,
  style: propTypes.object
};

export default SearchSelect;
